import { render, staticRenderFns } from "./list-body.vue?vue&type=template&id=e6dee5da&scoped=true&"
import script from "./list-body.vue?vue&type=script&lang=js&"
export * from "./list-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dee5da",
  null
  
)

export default component.exports